export const LinkName = ({ name, setName, error }) => {
    const urlTitleChange = (e) => {
        setName(e.target.value)
    }

    return (
        <div
            className="modalContentWrapper linkOptionsWrapper"
            style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: "10px" }}
        >
                <label htmlFor="link-name">Link Name (Meta Data):</label>
                <input
                    required
                    className={error == true ? "errorLink" : " "}
                    id="link-name"
                    value={name}
                    onChange={urlTitleChange}
                    placeholder="Name your link."
                    type="text"
                />
        </div>
    )
}